import Vue       from 'vue'
import lineClamp from 'v-line-clamp'
import Clipboard from 'vue-clipboard2'


Vue.use(lineClamp, {
  // plugin options
})
Vue.use(Clipboard)
